// @ts-check
import { createCrudProp } from '../utils/crud-prop'
import { nullIfEmpty, removeKeysWithEmptyValues } from '../utils/object'
import { createSelector } from '../utils/selector-utils'
import { sortByTimeIfExists } from '../utils/sort-by'

const preMedProp = createCrudProp({
  rootKey: 'preMedsAdministered',
  idPrefix: 'pmed',
  sortFn: sortByTimeIfExists,
})

/**
 * @param {boolean} preMedsUsed
 * @returns {any} The changes to apply to the case.
 */
export const actionPreMedsUsed = preMedsUsed => ({ preMedsUsed })

/**
 * @param {PreMedEditable} [props]
 * @returns {any} The changes to apply to the case.
 */
export const actionAddPreMed = props => ({
  ...preMedProp.actionAdd({
    time: Date.now(),
    editing: true,
    ...props,
  }),
  ...actionPreMedsUsed(true),
})

/**
 * @param {string} id The preMed ID
 * @returns {any} The changes to apply to the case.
 */
export const actionRemovePreMed = preMedProp.actionRemove

/**
 * @param {string} id The airway ID
 * @param {PreMedEditable} updates The updates to apply to the preMed
 * @returns {any} The changes to apply to the case.
 */
export const actionUpdatePreMed = preMedProp.actionUpdate

/**
 * @param {CaseData} caseData
 * @returns {PreMed[]}
 */
export const selectPreMeds = preMedProp.select

/**
 * @param {CaseData} caseData
 * @returns {{ [id: string]: Omit<PreMed, 'id'> }}
 */
export const selectPreMedsRaw = preMedProp.selectRaw

/**
 * @param {CaseData} caseData
 * @returns {boolean | null}
 */
export const selectPreMedsUsed = caseData => caseData.preMedsUsed

/**
 * @param {CaseData} caseData
 * @returns {boolean}
 */
export const selectHasAnsweredPreMed = caseData => {
  const answer = selectPreMedsUsed(caseData)
  return answer === true || answer === false
}

/**
 * @param {CaseData} caseData
 * @returns {MacroPreMed[] | null}
 */
export const selectPreMedsForMacro = createSelector(selectPreMeds, preMeds =>
  nullIfEmpty(
    preMeds
      .filter(preMed => preMed.drugId && preMed.drugName)
      .map(preMed =>
        removeKeysWithEmptyValues({
          drugId: preMed.drugId,
          drugName: preMed.drugName,
          route: preMed.route,
          dosage: preMed.dosage,
          unit: preMed.unit,
        })
      )
  )
)
